import * as Yup from "yup";

// Ajustamos para que title/description sean obligatorios SOLO si es creación
export function initialValues(ticket) {
  return {
    title: ticket?.title || "",
    description: ticket?.description || "",
    // Si ticket existe, interpretamos "message" como "nueva respuesta"
    message: "", 
  };
}

export function validationSchema(isCreation) {
  return Yup.object({
    title: isCreation
      ? Yup.string().required("El título es obligatorio")
      : Yup.string().optional(),
    description: isCreation
      ? Yup.string().required("La descripción es obligatoria")
      : Yup.string().optional(),
    message: Yup.string().required("El mensaje es obligatorio"),
  });
}
